import remote from '../remote'

const state = {
  articles: []
}

const getters = {
  FERALCOARTICLES: state => {
    return state.articles
  },
  FERALCOARTICLE_BY_NAME: (state, getters) => (name) => {
    return state.articles.find(article => article.data.articleId === name)
  }
}

const mutations = {
  SET_FERALCOARTICLES: (state, payload) => {
    state.articles = payload
  }
}

const actions = {
  GET_FERALCOARTICLES: async (context, payload) => {
    let { data } = await remote().get('/api/objectdatas/objectdescriptionid/18')
    context.commit('SET_FERALCOARTICLES', data)
  }
}

export default {
  state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/modules/feralcoarticle.js